/* RAWNAQ × OMES — brand page behaviour. Theme asset: assets/rawnaq-brand.js (defer).
   Follow toggle (hero + mobile bar), mobile sticky CTA bar after the hero, éditorial carousel dots. */
(function () {
  var root = document.querySelector('.vms');
  if (!root) return;
  // « Suivre la marque » is the theme's follow (assets/omes-brand-follow.js, data-follow).

  var hero = root.querySelector('[data-rq-hero]'), bar = root.querySelector('[data-rq-bar]');
  if (hero && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { bar.classList.toggle('show', !en[0].isIntersecting); }, { threshold: 0.05 }).observe(hero);
  }
  var arc = root.querySelector('[data-rq-arc]'), dots = root.querySelector('[data-rq-dots]');
  if (arc && dots) {
    arc.addEventListener('scroll', function () {
      var it = arc.children; if (!it.length) return;
      var w = it[0].getBoundingClientRect().width + 12;
      var i = Math.max(0, Math.min(it.length - 1, Math.round(arc.scrollLeft / w)));
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
    }, { passive: true });
  }
})();
